/* eslint-disable react/prefer-stateless-function,no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';
import { t } from 'utils/translates';
import { changeFieldTimeTargetAddWeekdays } from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/actions';
import { selectFieldTimeTarget } from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/selectors';
import TimeTargetWeekDaysItem from './TimeTargetWeekDaysItem';

class TimeTargetTaskInputs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasTimeTargetShow: this.props.fieldTimeTarget.value.length > 0
    };
  }

  componentDidMount() {
    if (this.state.hasTimeTargetShow) {
      // eslint-disable-next-line no-undef
      $(`#collapseTime`).collapse('show');
    }
  }

  render() {
    return (
      <React.Fragment>
        <div
          aria-multiselectable="true"
          className="panel-group"
          id="panelGroupTimetarget"
          role="tablist"
        >
          <section className="panel panel-default panel-heading_padding-large">
            <div className="panel-heading" role="tab">
              <h2 className="panel-title">
                <a
                  aria-controls="filter-collapseTime"
                  aria-expanded="false"
                  className="dropdown-toggle dropdown-toggle-collapse collapsed"
                  data-toggle="collapse"
                  href="#collapseTime"
                  role="button"
                >
                  <i className="fa fa-clock-o fa-fw" />{' '}
                  {t('Таргетинг по времени')}
                </a>
              </h2>
            </div>
            <div
              aria-labelledby="headingOne"
              className="panel-collapse collapse"
              id="collapseTime"
              role="tabpanel"
              aria-expanded="false"
            >
              <div className="panel-body bg-sub">
                <div className="form-group">
                  <p className="form-control-static text-center text-muted full-width">
                    {t(
                      'Здесь Вы можете задать время, когда Ваше задание будет доступно для выполнения и необходимое количество выполнений в этот период.'
                    )}
                  </p>
                </div>
                {this.props.fieldTimeTarget.value.map((item, index) => (
                  <TimeTargetWeekDaysItem
                    key={`timeTargetWeekDaysItem-${index + 1}`}
                    reducerName={this.props.reducerName}
                    weekDaysIndex={index}
                    weekDayTimeTargetItem={item}
                  />
                ))}

                <div className="form-group m-b-0">
                  <button
                    className="btn btn-default"
                    onClick={() =>
                      this.props.changeFieldTimeTargetAddWeekdays()
                    }
                    type="button"
                  >
                    <i className="fa fa-plus" /> {t('Добавить дни выполнения')}
                  </button>
                </div>
              </div>
            </div>
          </section>
        </div>
      </React.Fragment>
    );
  }
}

TimeTargetTaskInputs.propTypes = {
  reducerName: PropTypes.string.isRequired,

  fieldTimeTarget: PropTypes.shape({
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,

  changeFieldTimeTargetAddWeekdays: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  fieldTimeTarget: selectFieldTimeTarget(state, props.reducerName)
});

const mapDispatchToProps = (dispatch, props) => ({
  changeFieldTimeTargetAddWeekdays: () =>
    dispatch(changeFieldTimeTargetAddWeekdays(props.reducerName))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TimeTargetTaskInputs);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskFrom/TimeTargetTaskInputs/TimeTargetTaskInputs.js